/* Reviewed presentation names. Changed merchant or translated titles always win. */
(function (win) {
  'use strict';
  var node = win.document.querySelector('[data-pg-product-titles]');
  var names = {};
  try { names = node ? JSON.parse(node.textContent) : {}; } catch (_) { return; }
  win.PGProductTitle = function (handle, title) {
    var entry = Object.prototype.hasOwnProperty.call(names, handle) ? names[handle] : null;
    var shown = entry && entry.source === title ? entry.title : title;
    // Same as the Liquid snippet: " | " reads like a capital I in Manrope, show " · ".
    return typeof shown === 'string' ? shown.split(' | ').join(' \u00b7 ') : shown;
  };
})(window);
